export default __webpack_public_path__ + "static/media/g.465b7762.png";